import TrialForm from "./components/TrialForm";
import FullscreenOverlay from "./components/FormOverlay";
import React, { useState, useEffect, Suspense, startTransition } from 'react';
import Warning from "./Warning";
import NotificationSnackbar from "./components/Snackbar";
import AuthProvider from "./components/AuthProvider";

export default function App({ id, type, portal, children }) {
  const [showOverlay, setShowOverlay] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [notification, setNotification] = useState({code: "", type: "", text: ""});
  const [warningSettings, setWarningSettings] = useState({msgPrimary: "", msgSecondary: "", disableProceed: false});
  const [openNotification, setOpenNotification] = useState(false);

  function showNotification(show) {
    setOpenNotification(show);  
  }

  const fetchUserData = async() => {
    try {
        const response = await fetch('/wp-json/home/check-patient', {
            method: 'GET'
        });
        if (!response.ok) {
            throw new Error(`Network response was not ok (Status: ${response.status})`);
        }
        const data = await response.json();
        // console.log('✅ Response from API:', data);
        return data;

    } catch (error) {
        // console.error('❌ API Error:', error);
        return {
            success: false,
            valid: false,
            message: 'API failed or JSON was invalid.'
        };
    }
  }

    // const response = await fetchUserData();
  // // console.log(response);
  // let msgPrimary, msgSecondary, disableProceed;
  // if (response.valid === false){
  //   setShowWarning(true);
  //   if (response.block === true){
  //     msgPrimary = "You have reached your daily limit for form submissions.";
  //     msgSecondary = "Please try again on another day.";
  //     disableProceed = true;
  //   } else {
  //     msgPrimary = `It looks like you have already submitted a request to the surgeons.
  //           Proceeding will update your existing request and resend your data to the surgeon.`;
  //     msgSecondary = `Are you sure you want to continue to the form?`;
  //     disableProceed = false;
  //   }
  //   setWarningSettings(prevState => ({
  //       ...prevState,
  //       msgPrimary: msgPrimary,
  //       msgSecondary: msgSecondary,
  //       disableProceed: disableProceed
  //   }));
  // }

  // useEffect(() => {
  //   // const button = document.querySelector('.form-btn-custom');
  //   const button = document.querySelector('.form-btn-' + type);
  //   const handleClick = async() => {
  //     startTransition(() => {
  //       setShowOverlay(true);
  //       // document.body.style.overflow = "hidden";
  //     });
  //   };

  //   if (button) {
  //     button.addEventListener('click', handleClick);
  //   }

  //   return () => {
  //     if (button) {
  //       button.removeEventListener('click', handleClick);
  //     }
  //   };
  // }, []);

  useEffect(() => {
    const buttons = document.querySelectorAll('.form-btn-' + type);

    const handleClick = async () => {
      startTransition(() => {
        setShowOverlay(true);
      });
    };
    buttons.forEach(button => {
      button.addEventListener('click', handleClick);
    });
    return () => {
      buttons.forEach(button => {
        button.removeEventListener('click', handleClick);
      });
    };
  }, [type]);

  useEffect(() => {
    if (showOverlay) {
      document.body.classList.add('no-scroll');
    }
    return () => {
      document.body.classList.remove('no-scroll');
    };
    
  }, [showOverlay]);

  // const handleClose = () => setShowOverlay(false);
  // const FullscreenOverlay = lazy(() => import('./FormOverlay'));  
  function handleDataFromChild(data) {
    // setOpenNotification(true);
    setShowOverlay(data);
    document.body.style.overflow = "scroll";
  }

  // const handleOpenWarning = () => setShowWarning(true);
  const handleCloseWarning = () => {
    setShowWarning(false);
    // document.body.style.overflow = "auto !important";
    // document.documentElement.style.overflow = "";
  };
  const handleCancelWarning = () => handleDataFromChild(false);

  return (
    <>
      <NotificationSnackbar 
        notification={notification}
        open={openNotification}
        showNotification={showNotification}
      />
      {showOverlay && (
        <Suspense fallback={
          // <div>Loading...</div>
          <div class="loading-container">
            <svg class="spinner" viewBox="0 0 50 50">
                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5" stroke-linecap="round"/>
            </svg>
          </div>
        }
        >
          <AuthProvider>
          <FullscreenOverlay notify={handleDataFromChild} portal={portal}>
           {/* <h1>Hello from the overlay!</h1> */}
           {showWarning ? 
           (<Warning 
              isOpen={showWarning}
              onClose={handleCancelWarning}
              onProceed={handleCloseWarning}
              msgPrimary={warningSettings.msgPrimary}
              msgSecondary={warningSettings.msgSecondary}
              disableProceed={warningSettings.disableProceed}
           />):
           (<TrialForm 
            onClose={handleCancelWarning}
            setNotification={setNotification}
            setOpenNotification={setOpenNotification}
            questionType={type}
           />)}
           </FullscreenOverlay>
           </AuthProvider>
        </Suspense>  
      )}
    </>
  );
}
